import {
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Grid,
  Box,
  Checkbox,
  CheckboxProps,
} from '@mui/material'
import FormInput from 'components/ui/FormInput'
import { useFormContext } from 'react-hook-form'
import { TestResult } from 'types'

const CheckAllBox = (props: CheckboxProps) => (
  <Checkbox size="small" color="primary" {...props} style={{ paddingLeft: 0 }} />
)

interface Props {
  file: File
  testResult: TestResult
  isVerify: boolean
}

const Step2 = ({ testResult, file, isVerify = false }: Props) => {
  const { watch, getValues, setValue } = useFormContext()

  const { mappings } = watch()

  const allChecked = (() => {
    const search = {
      display: { tFound: false, fFound: false },
      edit: { tFound: false, fFound: false },
      verify: { tFound: false, fFound: false },
    }
    mappings?.forEach((m) => {
      for (const k in search) {
        m[k] ? (search[k].tFound = true) : (search[k].fFound = true)
      }
    })

    return {
      display: {
        allchecked: search.display.tFound && !search.display.fFound,
        indeterminate: search.display.tFound && search.display.fFound,
      },
      edit: {
        allchecked: search.edit.tFound && !search.edit.fFound,
        indeterminate: search.edit.tFound && search.edit.fFound,
      },
      verify: {
        allchecked: search.verify.tFound && !search.verify.fFound,
        indeterminate: search.verify.tFound && search.verify.fFound,
      },
    }
  })()

  const handleCheckAll = (checkType: 'display' | 'edit' | 'verify', checked?: boolean) => {
    getValues().mappings.forEach((m, idx) => setValue(`mappings[${idx}].${checkType}`, checked))
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <Box fontSize="h6.fontSize" pb={2}>
          正常に接続が完了しました
        </Box>
        <Box height="90%" bgcolor="text.disabled" p={2} display="flex" alignItems="center">
          <img width="100%" src={URL.createObjectURL(file)} />
        </Box>
      </Grid>
      <Grid item xs={6}>
        <Box fontSize="h6.fontSize" pb={2} fontWeight="fontWeightMedium">
          {file.name}
        </Box>
        <TableContainer style={{ height: '100%', maxHeight: '500px' }}>
          <Table size="small" aria-label="a dense table" stickyHeader>
            <TableHead data-testid="table-head-template-ocr">
              <TableRow>
                <TableCell>フィールド名</TableCell>
                <TableCell>
                  項目表示
                  <br />
                  <CheckAllBox
                    onChange={(e) => {
                      handleCheckAll('display', e.target.checked)
                    }}
                    checked={allChecked.display.allchecked}
                    indeterminate={allChecked.display.indeterminate}
                  />
                </TableCell>
                <TableCell>
                  編集
                  <br />
                  <CheckAllBox
                    onChange={(e) => {
                      handleCheckAll('edit', e.target.checked)
                    }}
                    checked={allChecked.edit.allchecked}
                    indeterminate={allChecked.edit.indeterminate}
                  />
                </TableCell>
                {isVerify && (
                  <TableCell>
                    ベリファイ <br />
                    <CheckAllBox
                      onChange={(e) => {
                        handleCheckAll('verify', e.target.checked)
                      }}
                      checked={allChecked.verify.allchecked}
                      indeterminate={allChecked.verify.indeterminate}
                    />
                  </TableCell>
                )}
              </TableRow>
            </TableHead>
            {testResult && (
              <TableBody data-testid="table-body-template-ocr">
                {testResult.mappings.map((row, idx) => (
                  <TableRow key={row.fieldName}>
                    <TableCell component="th" scope="row">
                      {row.fieldName}
                      <FormInput
                        name={`mappings[${idx}].fieldName`}
                        type="hidden"
                        defaultValue={row.fieldName}
                      />
                      <FormInput
                        name={`mappings[${idx}].order`}
                        type="hidden"
                        defaultValue={row.order}
                      />
                    </TableCell>
                    <TableCell>
                      <FormInput
                        name={`mappings[${idx}].display`}
                        type="checkbox"
                        defaultValue={row.display}
                      />
                    </TableCell>
                    <TableCell>
                      <FormInput
                        name={`mappings[${idx}].edit`}
                        type="checkbox"
                        defaultValue={row.edit}
                      />
                    </TableCell>
                    {isVerify && (
                      <TableCell>
                        <FormInput
                          name={`mappings[${idx}].verify`}
                          type="checkbox"
                          defaultValue={row.verify}
                        />
                      </TableCell>
                    )}
                  </TableRow>
                ))}
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  )
}

export default Step2
